<template>
  <div
    class="modal fade show"
    id="user-detail-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modal-default"
    aria-hidden="true"
    :class="{ 'd-block': show }"
    style="background: rgba(0, 0, 0, 0.5)"
    @click.self="close"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">用戶詳情</h5>
          <button
            type="button"
            class="btn-close text-dark"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-4" v-if="user">
          <div class="row">
            <!-- Left Column: User Profile -->
            <div class="col-md-4 text-center border-end">
              <div class="avatar avatar-xl position-relative mb-3">
                <img
                  :src="user.avatar || 'https://placehold.co/150'"
                  class="w-100 border-radius-lg shadow-sm"
                  alt="profile_image"
                />
              </div>
              <h5 class="font-weight-bolder">{{ user.name }}</h5>
              <p class="text-xs text-secondary mb-2">
                {{ user.is_seller ? "賣家" : "一般會員" }}
              </p>
              <div class="d-flex justify-content-center gap-2 mb-3">
                <span
                  class="badge badge-sm"
                  :class="
                    user.status === 'active'
                      ? 'bg-gradient-success'
                      : 'bg-gradient-danger'
                  "
                >
                  {{ user.status === "active" ? "啟用中" : "已停權" }}
                </span>
              </div>

              <!-- Social Bindings -->
              <div class="d-flex justify-content-center gap-3 mt-4">
                <div
                  class="text-center"
                  :class="user.line_id ? 'opacity-10' : 'opacity-4'"
                >
                  <i
                    class="fab fa-line text-success text-2xl mb-1"
                    style="font-size: 24px"
                  ></i>
                  <p class="text-[10px] text-xs font-weight-bold">
                    {{ user.line_id ? "已綁定" : "未綁定" }}
                  </p>
                </div>
                <div
                  class="text-center"
                  :class="user.google_id ? 'opacity-10' : 'opacity-4'"
                >
                  <i
                    class="fab fa-google text-danger text-2xl mb-1"
                    style="font-size: 24px"
                  ></i>
                  <p class="text-[10px] text-xs font-weight-bold">
                    {{ user.google_id ? "已綁定" : "未綁定" }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Right Column: Details -->
            <div class="col-md-8 ps-md-4">
              <h6
                class="text-uppercase text-body text-xs font-weight-bolder opacity-7 mb-3"
              >
                詳細資訊
              </h6>

              <div class="row mb-4">
                <div class="col-md-6 mb-3">
                  <label
                    class="text-xs text-secondary font-weight-bold uppercase"
                    >Email</label
                  >
                  <p class="text-sm font-weight-bold mb-0">{{ user.email }}</p>
                </div>
                <div class="col-md-6 mb-3">
                  <label
                    class="text-xs text-secondary font-weight-bold uppercase"
                    >電話</label
                  >
                  <p class="text-sm font-weight-bold mb-0">
                    {{ user.phone || "未設定" }}
                  </p>
                </div>
                <div class="col-md-6 mb-3">
                  <label
                    class="text-xs text-secondary font-weight-bold uppercase"
                    >註冊日期</label
                  >
                  <p class="text-sm font-weight-bold mb-0">
                    {{ formatDate(user.created_at) }}
                  </p>
                </div>
                <div class="col-md-6 mb-3">
                  <label
                    class="text-xs text-secondary font-weight-bold uppercase"
                    >最後登入</label
                  >
                  <p class="text-sm font-weight-bold mb-0">
                    {{ formatDate(user.last_login_at) || "無紀錄" }}
                  </p>
                </div>
              </div>

              <h6
                class="text-uppercase text-body text-xs font-weight-bolder opacity-7 mb-3"
              >
                收件資訊
              </h6>
              <div class="row mb-4">
                <div class="col-12 mb-2">
                  <span class="text-xs text-secondary font-weight-bold me-2"
                    >地址:</span
                  >
                  <span class="text-sm text-dark">{{ fullAddress(user) }}</span>
                </div>
                <div class="col-12" v-if="user.seven_eleven_store_name">
                  <span class="text-xs text-secondary font-weight-bold me-2"
                    >7-11 門市:</span
                  >
                  <span class="text-sm text-dark">
                    {{ user.seven_eleven_store_name }} ({{
                      user.seven_eleven_store_id
                    }})
                  </span>
                </div>
              </div>

              <h6
                class="text-uppercase text-body text-xs font-weight-bolder opacity-7 mb-3"
              >
                統計數據
              </h6>
              <div class="row">
                <div class="col-md-4">
                  <div class="border border-radius-md p-3 text-center">
                    <h6 class="text-secondary text-xs mb-0">總訂單數</h6>
                    <h4 class="font-weight-bolder mb-0">
                      {{ user.orders_count || 0 }}
                    </h4>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="border border-radius-md p-3 text-center">
                    <h6 class="text-secondary text-xs mb-0">消費總額</h6>
                    <h4 class="font-weight-bolder mb-0 text-success">
                      ${{ (user.total_spent || 0).toLocaleString() }}
                    </h4>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="border border-radius-md p-3 text-center">
                    <h6 class="text-secondary text-xs mb-0">警告次數</h6>
                    <h4 class="font-weight-bolder mb-0 text-danger">
                      {{ user.warning_count || 0 }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn bg-gradient-secondary"
            @click="close"
          >
            關閉
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserDetailModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["close"],
  methods: {
    close() {
      this.$emit("close");
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString("zh-TW");
    },
    fullAddress(user) {
      if (!user.city && !user.address) return "未設定";
      return `${user.postal_code || ""} ${user.city || ""}${
        user.district || ""
      }${user.address || ""}`;
    },
  },
};
</script>
